export default "__VITE_ASSET__DqDMtWd8__"